import { mergeSharedTranslations } from "@shared/utils/mergeSharedTranslations";

import { accountClaim } from "./accountClaim";
import { ascension } from "./ascension";
import { common } from "./common";
import { directLabsCheckout } from "./directLabsCheckout";
import { error } from "./error";
import { intake } from "./intake";
import { journeyCheckout } from "./journeyCheckout";
import { linkNotification } from "./linkNotification";
import { multiplatformNotification } from "./multiplatformNotification";
import { officeSignUp } from "./officeSignUp";
import { patientRxAuth } from "./patientRxAuth";
import { practitionerSignUp } from "./practitionerSignUp";
import { regionSelector } from "./regionSelector";
import { signIn } from "./signIn";
import { UH } from "./UH";

export const US = mergeSharedTranslations({
  accountClaim,
  common,
  error,
  officeSignUp,
  patientRxAuth,
  practitionerSignUp,
  linkNotification,
  multiplatformNotification,
  regionSelector,
  signIn,
  intake,
  journeyCheckout,
  directLabsCheckout,
  UH,
  ascension,
  emerson: {
    header: {
      Title: "Emerson Ecologics",
    },
  },
});
